
export function scrollToView(el,spacer = 0){
    window.scrollTo({
        top: window.scrollY + el.getBoundingClientRect().top - spacer,
        left: 0,
        behavior: 'smooth'
    });
}